import { Link, useNavigate } from "react-router";
import {
    Button,
    Card,
    CardBody,
    CardLink,
    CardText,
    CardTitle,
    Col,
    Container,
    Row,
} from "reactstrap";
import useAuth from "../hooks/useAuth";

export default function Home() {
    const { auth, setAuth } = useAuth();
    const navigate = useNavigate();

    if (auth.viewLevel === "adminreports") {
        navigate('/');
    }

    return (
        <Container>
            <Card>
                <CardBody>
                    <Row>
                        <Col className="col-4 flex-fill">
                            <Card className="border-0">
                                <CardBody className="text-center">
                                    <CardTitle tag="h5">My Training Plan Progress Report</CardTitle>
                                    <CardText>See your progress on your Training Plans.</CardText>
                                    <Link
                                        to="/myreports/learningplan/form"
                                        className="btn btn-primary mx-auto"
                                    >
                                        View
                                    </Link>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col className="col-4 flex-fill">
                            <Card className="border-0">
                                <CardBody className="text-center">
                                    <CardTitle tag="h5">
                                        <span className="newFeature">
                                            My Detailed Completions Report
                                        </span>
                                    </CardTitle>
                                    <CardText>
                                        See the courses you have completed, and the training hours you have accumulated.
                                    </CardText>
                                    <Link
                                        to="/myreports/detailedcompletions/form"
                                        className="btn btn-primary mx-auto"
                                    >
                                        View
                                    </Link>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col className="col-4 flex-fill">
                        </Col>
                    </Row>
                </CardBody>
            </Card>
        </Container>
    );
}
